import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import _get from 'lodash/get';

import ProductCover from 'Components/Utility/ProductCover';
import ProductEditionAddtoCartBtn from 'Components/Product/ProductEditions/ProductEditionsAddToCartBtn';
import ProductDiscountPrice from 'Components/Product/ProductCommerce/ProductDiscountPrice';
import ProductPrice from 'Components/Product/ProductCommerce/ProductPrice';
import ProductEditionKeyPoints from 'Components/Product/ProductEditions/ProductEditionKeyPoints';
import 'Components/Product/ProductCommerce/PriceContainer.scss';
import 'Components/Product/ProductEditions/ProductEditionCard.scss';

const ProductEditionCard = ({
  coverType,
  displayType,
  edition,
  currentPageSlug,
  presale,
  isCheckoutCard,
}) => {
  if (!edition) return false;

  const { slug, price, current_discount: currentDiscount, type, editionPoints, cover } = edition;

  const editionName = _get(edition, 'edition_name', edition.name);

  const selected = slug === currentPageSlug;


  return (
    <article className={classNames('ProductEditionCard faux-block-link',
      { 'ProductEditionCard--selected': selected })}
    >
      <ProductCover
        lazy
        cover={cover}
        alt={`Product cover for ${editionName}`}
        sizesOverride="(min-width: 1520px) 430px, (min-width: 1200px) 360px, (min-width: 992px) 360px, (min-width: 768px) 339px, 98vw"
        coverType={coverType}
        displayType={displayType}
      />

      <div className="ProductEditionCard__content">
        <h3 className="ProductEditionCard__editionName h4">{editionName}</h3>
        <Link to={`/${type}/${slug}`} className="faux-block-link__overlay-link" aria-label={`View ${editionName}`} />
        <ProductEditionKeyPoints keyPoints={editionPoints} />

        {!currentDiscount && !presale &&
          <ProductPrice
            price={price}
            slug={slug}
          />
        }

        {currentDiscount && !presale &&
          <ProductDiscountPrice
            price={edition.price}
            currentDiscount={currentDiscount}
            slug={slug}
          />
        }

        {!presale && !isCheckoutCard &&
          <ProductEditionAddtoCartBtn
            product={edition}
          />
        }

      </div>
    </article>
  );
};


ProductEditionCard.propTypes = {
  coverType: PropTypes.string,
  displayType: PropTypes.string,
  edition: PropTypes.shape({}),
  currentPageSlug: PropTypes.string,
  presale: PropTypes.bool,
  isCheckoutCard: PropTypes.bool,
};

ProductEditionCard.defaultProps = {
  coverType: '',
  displayType: '',
  edition: null,
  currentPageSlug: '',
  presale: false,
  isCheckoutCard: false,
};

export default ProductEditionCard;
